import React from 'react';

const Custom = (props) => {
    return <div className={'nh-window__custom'}>{props.content}</div>
};

export default Custom;
